import { PriceObjectDtoSchema } from "@modules/common/priceObject/gateway/priceObjectApiDto"
import { ProgramTrialSubscriptionDtoSchema } from "@modules/common/trialSubscription/gateway/trialSubscriptionApiDto"
import { ProgramPaymentDtoSchema } from "@modules/programs/gateway/programDto"
import { ProgramSubscriptionStatus } from "@modules/programs/types/programTypes"
import { z } from "zod"

export const StripeProgramSubscriptionDtoSchema = z
  .object({
    subscriptionId: z.string(),
    subscriptionStatus: z.enum(ProgramSubscriptionStatus),
    periodEndDate: z.string().nullable(),
    referencePrice: PriceObjectDtoSchema.nullable(),
    paidPrice: PriceObjectDtoSchema.nullable(),
    nextPayment: PriceObjectDtoSchema.nullable(),
    trial: ProgramTrialSubscriptionDtoSchema.nullable(),
    payment: ProgramPaymentDtoSchema.nullable(),
  })
  .meta({ id: "StripeProgramSubscriptionDtoSchema" })

export type StripeProgramSubscriptionDto = z.infer<typeof StripeProgramSubscriptionDtoSchema>
